export default __webpack_public_path__ + "static/media/Template7.7e3574b2.png";